<div class="container" [class.pb-2]="hasDelegations">
  <li role="none" (click)="$event.preventDefault(); $event.stopPropagation()">
    <a
      class="layout-topbar-action-item cursor-default"
      role="menuitem"
      style="border-bottom: 0"
    >
      <span
        class="flex items-center"
        [class.empty-delegations]="!hasDelegations"
      >
        <span class="px-2 icon-user-profile-back"></span>
        <span>
          {{ "labels.DELEGATIONS" | translate }}
        </span>
      </span>
    </a>
  </li>

  <ng-container
    *ngIf="!!activeDelegation"
    [ngTemplateOutlet]="delegationOutlet"
    [ngTemplateOutletContext]="{
      delegation: activeDelegation,
      isActive: true,
    }"
  />

  <div class="delegations">
    <ng-container
      *ngFor="let delegation of delegations"
      [ngTemplateOutlet]="delegationOutlet"
      [ngTemplateOutletContext]="{ delegation: delegation }"
    />
  </div>

  <div
    *ngIf="delegations.length && delegations.length !== allDelegations.length"
    class="w-100 flex justify-center mt-2"
  >
    <button
      class="load-all-delegation cursor-pointer"
      (click)="
        $event.preventDefault();
        $event.stopPropagation();
        delegations = allDelegations
      "
    >
      {{ "DELEGATIONS.SEE_ALL_DELEGATIONS" | translate }}
    </button>
  </div>
</div>

<ng-template
  #delegationOutlet
  let-delegation="delegation"
  let-isActive="isActive"
>
  <div
    class="delegation-container flex flex-col"
    (click)="
      $event.preventDefault();
      $event.stopPropagation();
      !isActive && setDelegation(delegation)
    "
    (keydown)="
      $event.preventDefault();
      $event.stopPropagation();
      !isActive && setDelegation(delegation)
    "
    [ngClass]="{
      'active-delegation': isActive,
      'cursor-pointer': !isActive,
    }"
  >
    <div class="delegation-item">
      <span class="flex items-center gap-2">
        <div
          class="checkbox"
          [class.active-checkbox]="isActive"
          [class.in-active-checkbox]="!isActive"
        >
          <i *ngIf="isActive" class="pi pi-check"></i>
        </div>

        <img
          class="b-circle"
          [src]="
            delegation.delegator?._resolved?.mainPicture
              ? (delegation.delegator?._resolved?.mainPicture
                | getLink
                | async)
              : '/assets/images/avatar.jpg'
          "
          alt="main user info"
          width="24"
          height="24"
        />
        <span>
          {{ delegation.delegator?._resolved?.mainTitle | propertyTranslator }}
        </span>
      </span>

      <app-exit-delegation-button *ngIf="isActive" />
    </div>

    <span *ngIf="isActive" class="active-text">
      {{ "DELEGATIONS.YOU_ARE_FULLY_DELEGATED" | translate }}
    </span>
  </div>
</ng-template>
